import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/layout/AppShell";
import { Login } from "@/pages/Login";
import { Panel } from "@/pages/Panel";
import { Vehicles } from "@/pages/Vehicles";
import { VehicleForm } from "@/pages/VehicleForm";
import { VehicleDetail } from "@/pages/VehicleDetail";
import { Parts } from "@/pages/Parts";
import { PartForm } from "@/pages/PartForm";
import { Users } from "@/pages/Users";
import { UserForm } from "@/pages/UserForm";
import { Notifications } from "@/pages/Notifications";
import { Financings } from "@/pages/Financings";
import { Payments } from "@/pages/Payments";
import { More } from "@/pages/More";
import { Suggestions } from "@/pages/Suggestions";
import { Raffles } from "@/pages/Raffles";
import { RaffleDetail } from "@/pages/RaffleDetail";
import { RaffleForm } from "@/pages/RaffleForm";
import { Garantias } from "@/pages/Garantias";
import { Configuracion } from "@/pages/Configuracion";
import { Documentacion } from "@/pages/Documentacion";
import { Quotes } from "@/pages/Quotes";
import { QuoteForm } from "@/pages/QuoteForm";
import { QuoteDetail } from "@/pages/QuoteDetail";
import { QuoteRequests } from "@/pages/QuoteRequests";
import { PartDetail } from "@/pages/PartDetail";
import { UserDetail } from "@/pages/UserDetail";
import { FinancingDetail } from "@/pages/FinancingDetail";
import { PaymentDetail } from "@/pages/PaymentDetail";
import { NotFound } from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<Panel />} />
          <Route path="vehicles" element={<Navigate to="/vehicles/motorcycles" replace />} />
          <Route path="vehicles/motorcycles" element={<Vehicles fixedType="Motocicleta" />} />
          <Route path="vehicles/automobiles" element={<Vehicles fixedType="Carro" />} />
          <Route path="vehicles/new" element={<VehicleForm />} />
          <Route path="vehicles/:id" element={<VehicleDetail />} />
          <Route path="vehicles/edit/:id" element={<VehicleForm />} />
          <Route path="parts" element={<Parts />} />
          <Route path="parts/new" element={<PartForm />} />
          <Route path="parts/:id" element={<PartDetail />} />
          <Route path="parts/edit/:id" element={<PartForm />} />
          <Route path="users" element={<Users />} />
          <Route path="users/new" element={<UserForm />} />
          <Route path="users/:id" element={<UserDetail />} />
          <Route path="users/edit/:id" element={<UserForm />} />
          <Route path="quotes" element={<Quotes />} />
          <Route path="quotes/new" element={<QuoteForm />} />
          <Route path="quotes/edit/:id" element={<QuoteForm />} />
          <Route path="quotes/:id" element={<QuoteDetail />} />
          <Route path="quote-requests" element={<QuoteRequests />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="financings" element={<Financings />} />
          <Route path="financings/:id" element={<FinancingDetail />} />
          <Route path="payments" element={<Payments />} />
          <Route path="payments/:id" element={<PaymentDetail />} />
          <Route path="garantias" element={<Garantias />} />
          <Route path="raffles" element={<Raffles />} />
          <Route path="raffles/new" element={<RaffleForm />} />
          <Route path="raffles/edit/:id" element={<RaffleForm />} />
          <Route path="raffles/:id" element={<RaffleDetail />} />
          <Route path="configuracion" element={<Configuracion />} />
          <Route path="documentacion" element={<Documentacion />} />
          <Route path="more" element={<More />} />
          <Route path="suggestions" element={<Suggestions />} />
        </Route>
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
